import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
    isResidential: boolean
}
export default function TravelPlanCarSharingV2({ isReadOnly, isResidential }: IProps) {
    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => {
        const value = formValues[field];
        return value !== null && value !== undefined && value !== '';
    }) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={8} container>
                    {!isResidential && hasValues(["carSharing", "carSharingMonth", "carSharingYear"]) && (
                        <Grid container size={6} >
                            <DataContainer title="Car Sharing">
                                <Stack spacing={1}>
                                    <RenderSelectField name="carSharing" label="Are there features in place to encourage car-sharing at the site?" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'carSharingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'carSharingYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {!isResidential && hasValues(["freeRideHome", "freeRideHomeMonth", "freeRideHomeYear"]) && (
                        <Grid container size={6} >
                            <DataContainer title="Guaranteed Ride Home">
                                <Stack spacing={1}>
                                    <RenderSelectField name="freeRideHome" label="Is there a guaranteed free ride home for emergencies available to all car sharing staff?" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'freeRideHomeMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'freeRideHomeYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {!isResidential && hasValues(["carShareParking", "carShareParkingMonth", "carShareParkingYear"]) && (
                        <Grid container size={6} >
                            <DataContainer title="Priority Parking">
                                <Stack spacing={1}>
                                    <RenderSelectField name="carShareParking" label="Are there priority parking spaces for car-sharers close to building entrances?" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'carShareParkingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'carShareParkingYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                    {!isResidential && hasValues(["carClubEmployees"]) && (
                        <Grid container size={6} >
                            <DataContainer title="Car Club">
                                <RenderSelectField name="carClubEmployees" label="Is there a Car Club available within walking distance of the site that could be used by employees?" readOnly={isReadOnly} options={yesNoDropdown} />
                            </DataContainer>
                        </Grid>
                    )}
                    {isResidential && hasValues(["carClubResidents", "carClubMonth", "carClubYear"]) && (
                        <Grid container size={12} >
                            <DataContainer title="Car Sharing">
                                <Stack spacing={1}>
                                    <RenderSelectField name="carClubResidents" label="Is there a Car Club available within walking distance of the site that could be used by residents? (if so, provide details, along with any specific arrangements the site developer may have with Car Club companies.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                    <Grid size={12}>
                                        <Typography variant={"body2"}>Date Implemented</Typography>
                                    </Grid>
                                    <Stack direction="row" spacing={1}>
                                        <Grid size={6}>
                                            <ValidatedSelectElement name={'carClubMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                        </Grid>
                                        <Grid size={6}>
                                            <ValidatedTextField name={'carClubYear'} readOnly={isReadOnly} />
                                        </Grid>
                                    </Stack>
                                </Stack>
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12} >
                        <DataContainer title={"Additional Comments"}>
                            <RenderTextField name="carSharingComments" label="Specify details of all Travel Plan elements identified in this section, along with any other car sharing features not already covered." readOnly={isReadOnly} multiLine={true} rows={4} labelSize={12} inputSize={12} alwaysShow={true} />
                        </DataContainer>
                    </Grid>
                </Grid>
            </Grid>

        </>
    );
}
